import { FormControl } from '@angular/forms';
import * as moment_ from 'moment';

const moment = moment_;

export const expiryDateValidator = (control: FormControl): { [invalidExpiryDate: string]: boolean } => {
  if (control.value) {
    let date;
    const match = control.value.match(/^\d{1,2}\/\d{4}$/);

    if (!match) {
      return { invalidExpiryDate: true };
    }

    date = moment(control.value, 'MM/YYYY', true).endOf('month');

    if (!date.isValid() || date.isBefore(moment())) {
      return { invalidExpiryDate: true };
    }
  }

  return null;
};
